import React from "react";

const ModelViewVleresimGjinor1 = ({ tableContent }) => {
  return (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <thead>
          <tr>
            <th style={headerRedStyle}>Nr. Subjekti</th>
            <th style={headerRedStyle} colSpan="3">
              Nr. moderatorëve
            </th>
            <th style={headerRedStyle} colSpan="3">
              Nr. të ftuarve
            </th>
          </tr>
          <tr>
            <th style={subHeaderStyle}></th>
            <th style={subHeaderStyle}>Gjithsej</th>
            <th style={{ ...subHeaderStyle, backgroundColor: "#bbdefb" }}>
              Meshkuj
            </th>
            <th style={{ ...subHeaderStyle, backgroundColor: "#f8bbd0" }}>
              Femra
            </th>
            <th style={subHeaderStyle}>Gjithsej</th>
            <th style={{ ...subHeaderStyle, backgroundColor: "#bbdefb" }}>
              Meshkuj
            </th>
            <th style={{ ...subHeaderStyle, backgroundColor: "#f8bbd0" }}>
              Femra
            </th>
          </tr>
        </thead>
        <tbody>
          {tableContent.map((row, index) => {
            const totalModeratore =
              parseInt(row["Nr. moderatorëve meshkuj"] || 0) +
              parseInt(row["Nr. moderatorëve Femra"] || 0);
            const totalFtuar =
              parseInt(row["Nr. të ftuarve Meshkuj"] || 0) +
              parseInt(row["Nr. të ftuarve Femra"] || 0);
            return (
              <tr key={index}>
                <td style={cellStyle}>{row["Nr. Subjekti"]}</td>
                <td style={cellStyle}>{totalModeratore}</td>
                <td style={{ ...cellStyle, backgroundColor: "#bbdefb" }}>
                  {row["Nr. moderatorëve meshkuj"]}
                </td>
                <td style={{ ...cellStyle, backgroundColor: "#f8bbd0" }}>
                  {row["Nr. moderatorëve Femra"]}
                </td>
                <td style={cellStyle}>{totalFtuar}</td>
                <td style={{ ...cellStyle, backgroundColor: "#bbdefb" }}>
                  {row["Nr. të ftuarve Meshkuj"]}
                </td>
                <td style={{ ...cellStyle, backgroundColor: "#f8bbd0" }}>
                  {row["Nr. të ftuarve Femra"]}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

// Stilet
const headerRedStyle = {
  backgroundColor: "#c62828",
  color: "white",
  padding: "8px",
  border: "1px solid #ddd",
};

const subHeaderStyle = {
  backgroundColor: "white",
  color: "black",
  padding: "8px",
  border: "1px solid #ddd",
};

const cellStyle = {
  padding: "8px",
  border: "1px solid #ddd",
};

export default ModelViewVleresimGjinor1;
